var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmarkDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0103 2.54786C15.441 2.11716 15.441 1.42071 15.0103 0.994598C14.5796 0.568481 13.8832 0.563899 13.4571 0.994598L8.0046 6.44706L2.54756 0.990016C2.11686 0.559318 1.42041 0.559318 0.994293 0.990016C0.568176 1.42071 0.563594 2.11716 0.994293 2.54328L6.44676 7.99574L0.989711 13.4528C0.559012 13.8835 0.559012 14.5799 0.989711 15.0061C1.42041 15.4322 2.11686 15.4367 2.54298 15.0061L7.99544 9.55359L13.4525 15.0106C13.8832 15.4413 14.5796 15.4413 15.0057 15.0106C15.4319 14.5799 15.4364 13.8835 15.0057 13.4574L9.55328 8.00491L15.0103 2.54786Z",
    fill: "#4F546D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_3137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkDark);
export default __webpack_public_path__ + "static/media/xmark-dark.3dcaf22edfe2aac528eec903651fbdcf.svg";
export { ForwardRef as ReactComponent };